'use client';

import { Stack, styled, Typography } from "@mui/material";
import Link from "next/link";

export default function LegalNotice() {
    return (
        <Stack spacing={{ xs: 2, md: 4 }}>
            <Typography
                variant="body2"
                sx={{
                    fontSize: '1.55rem',
                    mb: 4
                }}
            >
                Info
            </Typography>
            <Stack spacing={2}>
                <LinkTypography variant="body2" color="text.primary">
                    <Link href="/impressum" prefetch>Impressum</Link>
                </LinkTypography>
                <LinkTypography variant="body2" color="text.primary">
                    <Link href="/privacy" prefetch>Datenschutz</Link>
                </LinkTypography>
            </Stack>
        </Stack>
    )
}


const LinkTypography = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    '&:hover': {
        color:theme.palette.primary.main,
    }
}));
